module.exports = __webpack_public_path__ + "static/portfolioOne-0392d4fda5a669edd520eaba2cf3b6cd.png";